import React from "react";

const clients = [
  "FIEM Industries Pvt. Ltd. (Unit V), Hosur",
  "Solidus Hiteck Pvt. Ltd., Bangalore",
  "Apex Die Cast Pvt. Ltd., Bangalore",
  "Dolphin Die Cast Pvt. Ltd., Bangalore",
  "SS India, Bangalore",
  "ICAM Solutions Pvt. Ltd., Bangalore",
  "Ken2V Pvt. Ltd., Bangalore",
  "Sansu Automotives Pvt. Ltd., Bangalore",
  "Radiant International Pvt. Ltd., Bangalore"
];

const testimonials = [
  {
    quote: "Consistent supply quality and prompt support have made them a dependable packaging partner for our operations.",
    author: "Industrial Procurement Team"
  },
  {
    quote: "Their custom packaging response time and delivery discipline help us maintain production schedules smoothly.",
    author: "Automotive Components Client"
  }
];

function Clients() {
  return (
    <div className="page-shell">
      <section className="page-hero">
        <div className="container">
          <p className="eyebrow">Clients</p>
          <h1>Trusted by businesses that need packaging to perform every single time</h1>
          <p>
            We serve industrial clients across manufacturing and engineering sectors with dependable packaging support.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="client-grid-detailed">
            {clients.map((client) => (
              <div className="client-detail-card" key={client}>
                <span className="trust-badge">Trusted Client</span>
                <h3>{client}</h3>
                <p>Custom packaging support, consistent quality, and responsive delivery coordination.</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-muted">
        <div className="container grid cards-2">
          {testimonials.map((item) => (
            <article key={item.author} className="testimonial-card">
              <p>{item.quote}</p>
              <strong>{item.author}</strong>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Clients;
